module.exports = __webpack_public_path__ + "img/jewelrybox.b8f5d51.webp";